import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_6'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_6',
  name: 'Does the facility have any of the following safety measures in place for stairs and raised platforms?',
  description:
    'The intent of this question is to determine if stairs and raised platforms are maintained in order to ensure worker safety.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'EXPOSED_OVERHEAD_WORKING_SURFACES_SUCH_AS_WORKING_DOCKS_MEZZANI',
      text: 'Exposed overhead working surfaces (such as working docks, mezzanine floors, exposed platforms) have adequate guardrails and fencing',
      externalIds: [
        {
          id: 'hs-10-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_STAIRWAYS_ARE_EQUIPPED_WITH_HAND_RAILINGS_IN_GOOD_CONDITION',
      text: 'All stairways are equipped with hand railings in good condition',
      externalIds: [
        {
          id: 'hs-10-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_FACILITY_STAIRWAY_STEPS_ARE_EVEN',
      text: 'All facility stairway steps are even',
      externalIds: [
        {
          id: 'hs-10-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_FACILITY_STEP_SURFACES_ARE_MADE_FROM_SLIP_RESISTANT_MATERIA',
      text: 'All facility step surfaces are made from slip resistant materials or have anti-slip protection (i.e. anti-slip stickers or embossed/rough surfaces)',
      externalIds: [
        {
          id: 'hs-10-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROTECTION_FROM_FALLING_OBJECTS_UNDERNEATH_GRADED_SURFACES',
      text: 'Protection from falling objects underneath graded surfaces',
      externalIds: [
        {
          id: 'hs-10-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-10-6x',
          version: 1.3,
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'EXPOSED_OVERHEAD_WORKING_SURFACES_SUCH_AS_WORKING_DOCKS_MEZZANI',
                'ALL_STAIRWAYS_ARE_EQUIPPED_WITH_HAND_RAILINGS_IN_GOOD_CONDITION',
                'ALL_FACILITY_STAIRWAY_STEPS_ARE_EVEN',
                'ALL_FACILITY_STEP_SURFACES_ARE_MADE_FROM_SLIP_RESISTANT_MATERIA',
                'PROTECTION_FROM_FALLING_OBJECTS_UNDERNEATH_GRADED_SURFACES',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13790,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
